import { Notify, Platform } from "quasar";

import { getLocaleText } from "shared/boot/i18n";

const position = Platform.is.capacitor ? "center" : "bottom";

export const notifyRemovalOfMentionFromBookmarkStream = (label) => {
  Notify.create({
    color: "primary",
    message: getLocaleText("helpers.action_notifications.removed_from", {
      label,
    }),
    position,
    timeout: 1300,
  });
};

export const notifyAdditionOfMentionToBookmarkStream = (label) => {
  Notify.create({
    color: "primary",
    message: getLocaleText("helpers.action_notifications.added_to", { label }),
    position,
    timeout: 1300,
  });
};
